const getStatusColor = (status) => {
  if (status?.includes('abnormal')) return 'var(--color-error50)';

  switch (status) {
    case 'Terdeteksi':
    case 'Telat Masuk':
    case 'Telat Pulang Lebih Awal':
    case 'Melebihi Batas':
      return 'var(--color-error50)';
    case 'Tepat Waktu':
    case 'Sesuai Batas':
      return 'var(--color-success60)';
    default:
      return 'var(--color-semantic-text)';
  }
};

export default getStatusColor;
